
@switch (linkType) {
  @case ('disabled') {
    <a
      [ngClass]="item | appSidebarNavLink"
      [appHtmlAttr]="item.attributes"
      >
      <app-sidebar-nav-link-content [item]="item"></app-sidebar-nav-link-content>
    </a>
  }
  @case ('external') {
    <a
      [ngClass]="item | appSidebarNavLink"
      [href]="href"
      [appHtmlAttr]="item.attributes" target="_blank"
      (click)="linkClicked()"
      >
      <app-sidebar-nav-link-content [item]="item"></app-sidebar-nav-link-content>
    </a>
  }
  @default {
    <a
      [ngClass]="item | appSidebarNavLink"
      [appHtmlAttr]="item.attributes"
      [target]="item.attributes?.target"
      [queryParams]="item.linkProps?.queryParams"
      [fragment]="item.linkProps?.fragment"
      [queryParamsHandling]="item.linkProps?.queryParamsHandling"
      [preserveFragment]="item.linkProps?.preserveFragment"
      [skipLocationChange]="item.linkProps?.skipLocationChange"
      [replaceUrl]="item.linkProps?.replaceUrl"
      [state]="item.linkProps?.state"
      [routerLink]="[finalUrl]"
      [class.active]="router.isActive(finalUrl,false)"
      (click)="linkClicked()"
      class="{{ (item.class_name != undefined) ? item.class_name : '' }}"
      >
      <app-sidebar-nav-link-content [item]="item"></app-sidebar-nav-link-content>
    </a>
  }
}
